<div>
  <div>
    <span>Selecione os filtros abaixo para a geração do relatório</span>

    <div class="formgrid grid p-fluid mt-5" style="width: 30rem">

        <div class="field col-12">
            <label for="situacao">Relatório: </label>
            <p-dropdown [options]="relatorios" optionLabel="relatorio" [(ngModel)]="relatorioSelecionado" inputId="id"></p-dropdown>
            <small class="p-error" *ngIf="gerado && !relatorioSelecionado">Necessário selecionar um relatório</small>
        </div>


        <div class="field col-12">
          <label for="periodo">Instâncias: </label>

          <p-multiSelect
            id="instancias"
            appendTo="body"
            [options]="instancias"
            [filter]="true"
            optionValue="id"
            optionLabel="nome"
            [(ngModel)]="instanciaSelecionada"
            dataKey="id"
            inputId="id"
            placeholder="Selecione a instância"
            emptyMessage="Nenhuma instância"
          >
          </p-multiSelect>
          <small class="p-error" *ngIf="gerado && !instanciaSelecionada">Necessário selecionar um relatório</small>
        </div>

        <div class="field col-12">
            <label for="periodo">Período: </label>

            <p-calendar
            [(ngModel)]="rangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            [readonlyInput]="true"
            (onClose)="onDateChange($event)"
            placeholder="Selecione o período"
          />
        </div>

        <div class="field col-12">
            <label for="situacao">Situação: </label>
            <p-dropdown [options]="situacoes" optionLabel="situacao" [(ngModel)]="situacaoSelecionada" inputId="id"></p-dropdown>
            <small class="p-error" *ngIf="gerado && !situacaoSelecionada">Necessário selecionar uma situação</small>
        </div>

        <div class="field col-12">
            <button pButton label="Gerar Relatório" icon="pi pi-report" [loading]="loading" (click)="gerarRelatorio()"></button>
        </div>
    </div>
  </div>
</div>
